import { thumbnailUrlGameId } from '@/libs/thumbnailGameId';

export function gameImageUrl(gameId, type, game = null) {
  const id = thumbnailUrlGameId(gameId, type, game);

  if (type === 'Jili') {
    return `https://cdn.myanmarshankoeme.com/build/assets/img/bf688/jili/${id}.webp`;
    // return `https://cdn.myanmarshankoeme.com/build/assets/img/fgg/${id}.webp`;
  }
  if (type === 'PGSoft') {
    // return `https://space-tech.sgp1.cdn.digitaloceanspaces.com/slot-images/pgsoft/pgsoft_${id}.webp`;
    return `https://cdn.myanmarshankoeme.com/build/assets/img/fgg/${id}.webp`;
  }
  if (type === 'Live22') {
    return `https://cdn.myanmarshankoeme.com/build/assets/img/bf688/live22/${id}.webp`;
  }
  if (type === 'Spade') {
    return `https://merchantapi.silverkirin88.com/thumbnail/en_US/${id}.jpg`;
  }
  if (type === 'Fastspin') {
    return `http://api-egame-staging.fsuat.com/thumbnail/en_US/${id}.jpg`;
  }
  if (type === 'Playstar') {
    return `https://cdn.myanmarshankoeme.com/build/assets/img/bf688/playstar/${id}.webp`;
  }
  if (type === 'FaChai') {
    return `https://cdn.myanmarshankoeme.com/build/assets/img/bf688/fachai/${id}.webp`;
  }
  if (type === 'PGSoft') {
    return `https://space-tech.sgp1.cdn.digitaloceanspaces.com/slot-images/pgsoft/pgsoft_${id}.webp`;
  }
  if (type === 'JOKER' || type === 'Joker') {
    return `https://space-tech.sgp1.cdn.digitaloceanspaces.com/slot-images/joker/${id}.webp`;
  }
  if (type === '5G') {
    return `https://cdn.myanmarshankoeme.com/build/assets/img/bf688/5g/${id}.webp`;
  }
  if (type === 'KA') {
    return `https://cdn.myanmarshankoeme.com/build/assets/img/bf688/newKA/${id}.webp`;
  }
  if (type === 'AceWin') {
    return `https://cdn.myanmarshankoeme.com/build/assets/img/bf688/acewin/${id}_EN.webp`;
  }
  if (type === 'JDB') {
    return `https://cdn.myanmarshankoeme.com/build/assets/img/bf688/jdb/${id}.webp`;
  }
  if (type === 'Buffalo') {
    return `https://cdn.myanmarshankoeme.com/build/assets/img/bf688/pp/${id}.webp`;
  }
  if (type === 'HotDog') {
    return `https://res.hotdog-gaming.com/banners/380x500/${id}.png`;
  }
  if (type === 'Rich') {
    return `https://cdn.myanmarshankoeme.com/build/assets/img/bf688/rich/${id}.webp`;
  }
  if (type === 'Rich88') {
    return `https://cdn.myanmarshankoeme.com/build/assets/img/bf688/rich88/${id}.webp`;
  }
  if (type === 'CQ9' || type === 'cq9' || type === 'SexySlot') {
    return `https://space-tech.sgp1.cdn.digitaloceanspaces.com/slot-images/cq9/cq9_${id}.webp`;
  }
  if (type === 'BTG') {
    return `https://cdn.myanmarshankoeme.com/build/assets/img/bf688/btg/${id}.webp`;
  }
  if (type === '2J') {
    return `https://cdn.myanmarshankoeme.com/build/assets/img/bf688/2j/${id}.webp`;
  }
  if (type === 'VA') {
    return `https://cdn.myanmarshankoeme.com/build/assets/img/bf688/va/${id}_en.webp`;
  }
  if (type === 'BNG') {
    return `https://cdn.myanmarshankoeme.com/build/assets/img/bf688/bng/${id}.webp`;
  }
  if (type === 'AfricanBuffalo') {
    return `https://cdn.myanmarshankoeme.com/build/assets/img/bf688/afb/${id}.webp`;
  }

  // return `https://cdn.myanmarshankoeme.com/build/assets/img/bf688/pp/${id}.webp`;
  return `https://cdn.myanmarshankoeme.com/build/assets/img/fgg/${id}.webp`;
}
